/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/11/21
 */
import React from 'react';
import { Button, Center, Text, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NotFoundProps {}

const NotFound: React.VFC<NotFoundProps> = () => {
    return (
        <Center>
            <VStack spacing={4} m={8}>
                <Text fontSize="lg">Page not found</Text>
                <Link to="/">
                    <Button>Return to Home</Button>
                </Link>
            </VStack>
        </Center>
    );
};

export default NotFound;
